const POSITIONS = ['시', '일', '월', '년'];

/** 한자 사주원국을 천간, 지지를 각각 시일월년 순으로 정렬 */
export const splitToSkyEarth = (sajugangi) => {
  if (!sajugangi || sajugangi.length !== 8) {
    throw new Error('문자열 길이가 8이 아닙니다.');
  }

  const skyArr = sajugangi.slice(0, 4).split('');
  const earthArr = sajugangi.slice(4).split('');

  return skyArr.map((char, i) => ({
    sky: char,
    earth: earthArr[i],
    pos: POSITIONS[i],
  }));
};

/** 한글 사주원국을 천간, 지지를 각각 시일월년 순으로 정렬 */
export const splitToSkyEarthKor = (sajugangiKor) => {
  if (!sajugangiKor || sajugangiKor.length !== 8) {
    throw new Error('문자열 길이가 8이 아닙니다.');
  }

  const skyArr = [6, 4, 2, 0].map(i => sajugangiKor[i]);
  const earthArr = [7, 5, 3, 1].map(i => sajugangiKor[i]);

  return [0, 1, 2, 3].map(i => ({
    sky: skyArr[i],
    earth: earthArr[i],
    pos: POSITIONS[i],
  }));
};
